<template>
  <modal v-model="value.show">
    <div slot="content">
      <div class="ls-modal-header">
        <button data-dismiss="modal" close-modal>&times;</button>
        <h4 class="ls-modal-title">{{ $t('contracts.inactivate_automatic_debit.title') }}</h4>
      </div>
      <div class="ls-modal-body">
        <div class="ls-alert-warning">
          <strong>{{ $t('application.alert.warning') }}</strong> {{ $t('contracts.inactivate_automatic_debit.message') }}
        </div>
        <div v-html="$t('contracts.inactivate_automatic_debit.inactive_confirm')"></div>
      </div>
      <div class="ls-modal-footer">
        <button class="ls-btn" close-modal data-dismiss="modal">{{ $t('application.button.close') }}</button>
        <button type="submit" class="ls-btn-danger ls-float-right" @click.prevent="cancelDebit()">{{ $t('contracts.inactivate_automatic_debit.buttons.inactivate_debit')}}</button>
      </div>
    </div>
  </modal>
</template>
<script>
  import Modal from 'src/app/components/shareds/modal/Modal'
  import { mapMutations, mapActions, mapGetters } from 'vuex'

  export default {
    props: ['value'],
    components: { Modal },
    methods: {
      ...mapMutations(['clearFlash', 'addFlash']),
      ...mapActions(['inactivateDebit']),
      cancelDebit () {
        this.clearFlash
        this.inactivateDebit(this.contract).then(this.afertInactivate)
      },
      afertInactivate (response) {
        this.value.show = false
        if (response.status === 200) {
          this.$parent.getContract()
          this.addFlash({ message: this.$t('contracts.alerts.inactivate_debit_successfully'), type: 'ls-alert-success' })
        } else {
          this.addFlash({ message: this.$t('contracts.alerts.inactivate_debit_failure'), type: 'ls-alert-danger' })
        }
        if (this.value.callback) this.value.callback()
      }
    },
    computed: {
      ...mapGetters(['contract'])
    }
  }
</script>


// WEBPACK FOOTER //
// ModalInactivateAutomaticDebit.vue?8e833166